<div *ngIf="sheetData">

    <div class="alert alert-info" *ngIf="!sheetLoading && !sheetData.enrolledWorkDays.length">
        {{ l("NoEnrolledWorkDaysFound") }}
    </div>

    <div *ngFor="let day of sheetData.enrolledWorkDays">
        <app-allocation-conditions-form
            [enrolledWorkDay]="day"
            [sheetData]="sheetData"
            (refreshData)="getAllocationSheetForEdit($event)">
        </app-allocation-conditions-form>
    </div>
</div>


